import { useMediaQuery, useTheme } from '@mui/material'
import { alpha } from '@mui/material/styles';

export const useIsMobile = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('lg'));
}

export const getQuantityUrgencyColor = (quantity, theme) => {
  if (quantity < 10) {
    return alpha(theme.palette.error.main, 0.6);
  }
  if (quantity < 30) {
    return theme.palette.warning.light
  }
  return 'rgba(78, 215, 225, 0.15)'
}

export const getTimeUrgencyColor = (daysRemaining, theme) => {
  if (daysRemaining < 5) {
    return alpha(theme.palette.error.main, 0.6);
  }
  if (daysRemaining < 10) {
    console.log('Warning palette:', theme.palette.warning);
    return theme.palette.warning.light
  }
  return 'rgba(0,0,0,0)'; // transparent
}
